import { render } from "./Sidebar.vue?vue&type=template&id=7b5108b0&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=7b5108b0&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=7b5108b0&lang=css"
script.render = render
script.__scopeId = "data-v-7b5108b0"

export default script